import * as React from "react";

const FALLBACK_ID = "clip0_101_29885";

export interface StarEmptyProps extends React.SVGProps<SVGSVGElement> {
  /** Çoklu render'da SVG ID çakışmasını önlemek için benzersiz ID (opsiyonel) */
  clipPathId?: string;
}

function SvgComponent({ clipPathId, height = 36, width = 36, ...props }: StarEmptyProps) {
  const id = clipPathId ?? FALLBACK_ID;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <clipPath id={id}>
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${id})`}>
        <path
          d="M18.4659 26.8703C18.1744 26.7167 17.826 26.7166 17.5344 26.8699L10.5358 30.5494C9.80217 30.9352 8.9447 30.3122 9.08484 29.4953L10.4218 21.7015C10.4775 21.3769 10.3697 21.0457 10.1337 20.8159L4.46464 15.2977C3.87036 14.7192 4.19797 13.7104 5.01872 13.5914L12.8402 12.4579C13.1661 12.4106 13.4478 12.206 13.5935 11.9108L17.093 4.81994C17.4598 4.07669 18.5197 4.07669 18.8865 4.81994L22.386 11.9108C22.5317 12.206 22.8134 12.4106 23.1393 12.4579L30.9608 13.5914C31.7815 13.7104 32.1091 14.7192 31.5148 15.2977L25.8458 20.8159C25.6098 21.0457 25.502 21.3769 25.5577 21.7015L26.8942 29.4929C27.0345 30.3102 26.1761 30.9333 25.4424 30.5466L18.4659 26.8703Z"
          stroke="#E7212B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default SvgComponent;
